"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'dblogs.search.failed': 'Error al buscar los registros. Por favor, inténtelo de nuevo.',
};
